import * as React from 'react';
import {
    BodyMediumRegular,
    H2Emphasized,
    SafeAreaView,
    YStack,
} from 'smoothie';

import Logo from '../../../assets/images/logos/fruitful-logo-icon-only.svg';

const AccountUnderReview = () => {
    return (
        <SafeAreaView style={{ flex: 1 }}>
            <YStack
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
            >
                <YStack
                    alignItems="center"
                    gap={20}
                    padding={20}
                    width="100%"
                    maxWidth={500}
                >
                    <Logo width={32} height={28} />
                    <H2Emphasized textAlign="center">
                        Your account is under review
                    </H2Emphasized>
                    <BodyMediumRegular textAlign="center">
                        A member of our Hospitality team might reach out to you.
                        Please check back later.
                    </BodyMediumRegular>
                </YStack>
            </YStack>
        </SafeAreaView>
    );
};

export default AccountUnderReview;
